import { MagnifierIcon } from '@/components/primitives/icons/MagnifierIcon';
import {
  RESPONSE_ACTION_CARD_ICONS,
  RESPONSE_ACTION_CARD_TONES,
} from '@/constants/response';

import styles from './ButtonGrid.module.css';

import type { OverlayTriggerProps } from '@/components/patterns/OverlayDeck';
import type { ResolvedOverlayEntry } from '@/content/data/overlay-entries';

type ResponseActionCardProps = {
  entry: ResolvedOverlayEntry;
  triggerProps: OverlayTriggerProps;
  isActive: boolean;
};

export function ResponseActionCard({
  entry,
  triggerProps,
  isActive,
}: ResponseActionCardProps) {
  const toneIndex = Math.max(0, entry.order - 1) % RESPONSE_ACTION_CARD_TONES.length;
  const tone = RESPONSE_ACTION_CARD_TONES[toneIndex] ?? RESPONSE_ACTION_CARD_TONES[0];
  const actionIcon = RESPONSE_ACTION_CARD_ICONS[entry.id];

  return (
    <button
      type="button"
      className={[styles.button, isActive ? styles.buttonActive : '']
        .filter(Boolean)
        .join(' ')}
      data-tone={tone}
      {...triggerProps}
    >
      <MagnifierIcon className={styles.magnifierIcon} />
      <span className={styles.iconWrap} aria-hidden="true">
        {actionIcon ? (
          // SVG artwork keeps its exported dimensions inside the responsive art slot.
          // eslint-disable-next-line @next/next/no-img-element
          <img
            className={styles.actionIcon}
            src={actionIcon.src}
            width={actionIcon.width}
            height={actionIcon.height}
            alt=""
          />
        ) : null}
      </span>
      <span className={styles.buttonLabel}>{entry.title}</span>
    </button>
  );
}
